import { render, staticRenderFns } from "./lesson-star.vue?vue&type=template&id=52bb7070&scoped=true&lang=html"
import script from "./lesson-star.vue?vue&type=script&lang=js"
export * from "./lesson-star.vue?vue&type=script&lang=js"
import style0 from "./lesson-star.vue?vue&type=style&index=0&id=52bb7070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb7070",
  null
  
)

export default component.exports